import type { ProjectHealth, ProjectStatus } from '../../lib/projectsApi';
import { translate } from '../../lib/i18n';

// Active/success states use the filled green CCC variant (CLE-20); other states
// keep their soft semantic colors so the palette still communicates meaning.
const STATUS_STYLES: Record<ProjectStatus, string> = {
  PLANNING: 'bg-gray-100 text-gray-700',
  ACTIVE: 'bg-brand-600 text-white',
  ON_HOLD: 'bg-amber-100 text-amber-700',
  COMPLETED: 'bg-brand-600 text-white',
  CANCELLED: 'bg-red-100 text-red-700',
  ALMOST_DONE: 'bg-teal-100 text-teal-700',
  LEAD: 'bg-purple-100 text-purple-700',
  IN_HOUSE: 'bg-indigo-100 text-indigo-700',
};

const HEALTH_STYLES: Record<ProjectHealth, string> = {
  ON_TRACK: 'bg-brand-600 text-white',
  AT_RISK: 'bg-amber-100 text-amber-700',
  OFF_TRACK: 'bg-red-100 text-red-700',
};

export const PROJECT_STATUSES: ProjectStatus[] = [
  'PLANNING',
  'ACTIVE',
  'ALMOST_DONE',
  'ON_HOLD',
  'COMPLETED',
  'CANCELLED',
  'LEAD',
  'IN_HOUSE',
];

export const PROJECT_HEALTHS: ProjectHealth[] = ['ON_TRACK', 'AT_RISK', 'OFF_TRACK'];

// Labels are resolved through the i18n dictionary so they follow the active
// locale (CLE-278). `translate()` reads the live locale; the badges re-render
// with their parent when the language toggles.
export function statusLabel(status: ProjectStatus): string {
  return translate(`projects.status.${status}`);
}

export function healthLabel(health: ProjectHealth): string {
  return translate(`projects.health.${health}`);
}

export function StatusBadge({ status }: { status: ProjectStatus }) {
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {statusLabel(status)}
    </span>
  );
}

export function HealthBadge({ health }: { health: ProjectHealth }) {
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${HEALTH_STYLES[health]}`}
    >
      {healthLabel(health)}
    </span>
  );
}
